<template>
  <div class="Home">
    <SideBar></SideBar>

    <!-- 版心 -->
    <div class="_center WidCon">
      <!-- 切换显示内容 -->
      <div class="conent">
        <div class="conent_box">
          <h3>岗位模型分析</h3>
          <i class="selected"></i>
          <div class="swiperBox">
            <el-tabs stretch lazy v-model="activeName">
              <el-tab-pane label="人工智能产品、技术开发类" name="0">
                <div class="engineer">
                  <div class="engineerClass" v-for="item in tabList0" :key="item.name">
                    <div class="engineerTitle">{{ item.name }}</div>
                    <div class="engineerText">
                      <p>{{ item.list.p0 }}</p>
                      <p>{{ item.list.p1 }}</p>
                      <p>{{ item.list.p2 }}</p>
                      <p>{{ item.list.p3 }}</p>
                      <p>{{ item.list.p4 }}</p>
                      <p>{{ item.list.p5 }}</p>
                      <p>{{ item.list.p6 }}</p>
                      <p>{{ item.list.p7 }}</p>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="产品、技术测试类" name="1">
                <div class="engineer">
                  <div class="engineerClass" v-for="item in tabList1" :key="item.name">
                    <div class="engineerTitle">{{ item.name }}</div>
                    <div class="engineerText">
                      <p>{{ item.list.p0 }}</p>
                      <p>{{ item.list.p1 }}</p>
                      <p>{{ item.list.p2 }}</p>
                      <p>{{ item.list.p3 }}</p>
                      <p>{{ item.list.p4 }}</p>
                      <p>{{ item.list.p5 }}</p>
                      <p>{{ item.list.p6 }}</p>
                      <p>{{ item.list.p7 }}</p>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="系统运维类" name="2">
                <div class="engineer">
                  <div class="engineerClass" v-for="item in tabList2" :key="item.name">
                    <div class="engineerTitle">{{ item.name }}</div>
                    <div class="engineerText">
                      <p>{{ item.list.p0 }}</p>
                      <p>{{ item.list.p1 }}</p>
                      <p>{{ item.list.p2 }}</p>
                      <p>{{ item.list.p3 }}</p>
                      <p>{{ item.list.p4 }}</p>
                      <p>{{ item.list.p5 }}</p>
                      <p>{{ item.list.p6 }}</p>
                      <p>{{ item.list.p7 }}</p>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="系统集成与项目实施类" name="3">
                <div class="engineer">
                  <div class="engineerClass" v-for="item in tabList3" :key="item.name">
                    <div class="engineerTitle">{{ item.name }}</div>
                    <div class="engineerText">
                      <p>{{ item.list.p0 }}</p>
                      <p>{{ item.list.p1 }}</p>
                      <p>{{ item.list.p2 }}</p>
                      <p>{{ item.list.p3 }}</p>
                      <p>{{ item.list.p4 }}</p>
                      <p>{{ item.list.p5 }}</p>
                      <p>{{ item.list.p6 }}</p>
                      <p>{{ item.list.p7 }}</p>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="市场营销类" name="4">
                <div class="engineer">
                  <div class="engineerClass" v-for="item in tabList4" :key="item.name">
                    <div class="engineerTitle">{{ item.name }}</div>
                    <div class="engineerText">
                      <p>{{ item.list.p0 }}</p>
                      <p>{{ item.list.p1 }}</p>
                      <p>{{ item.list.p2 }}</p>
                      <p>{{ item.list.p3 }}</p>
                      <p>{{ item.list.p4 }}</p>
                      <p>{{ item.list.p5 }}</p>
                      <p>{{ item.list.p6 }}</p>
                      <p>{{ item.list.p7 }}</p>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="技术服务、技术支持类" name="5">
                <div class="engineer">
                  <div class="engineerClass" v-for="item in tabList5" :key="item.name">
                    <div class="engineerTitle">{{ item.name }}</div>
                    <div class="engineerText">
                      <p>{{ item.list.p0 }}</p>
                      <p>{{ item.list.p1 }}</p>
                      <p>{{ item.list.p2 }}</p>
                      <p>{{ item.list.p3 }}</p>
                      <p>{{ item.list.p4 }}</p>
                      <p>{{ item.list.p5 }}</p>
                      <p>{{ item.list.p6 }}</p>
                      <p>{{ item.list.p7 }}</p>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Vue, Prop, Component, Watch } from "vue-property-decorator";

@Component({
  components: {
    
  }
})
export default class Employment extends Vue {
// tab选中的栏
activeName= 0
      // 人工智能产品、技术开发类
      tabList0= [
        {
          name: '人工智能应用开发工程师',
          list: {
            p0:
              '1、良好的java、Python等语言的开发能力，快速开发前后端的各项功能；',
            p1:
              '2、能够应用开发语言调用人工智能相关的API、框架及算法，实现智能分析或预测等功能；',
            p2:
              '3、具备软件工程、设计模式、数据库等相关知识，可对人工智能系统进行软件架构、性能和功能方面优化和改进。'
          }
        },
        {
          name: '机器学习算法工程师',
          list: {
            p0:
              '1、熟练掌握C、C++、Python中的一种，能够自己动手实现自己构想的算法； ',
            p1: '2、熟悉机器学习的常用算法（比如聚类、决策树、回归、推荐）；',
            p2: '3、熟悉深度学习的常用网络搭建和训练（比如CNN、RNN、GAN等）；',
            p3:
              '4、具备机器学习、人工智能的工程化经验，在实际工程项目中使用过至少一种主p0:流的机器学习平台（Pytorch、Tensorflow）；',
            p4: '5、熟悉TensorFlow、MXNet、Pytorch、Caffe等人工智能开源平台。'
          }
        },
        {
          name: '图像处理工程师',
          list: {
            p0: '1、计算机或相关专业知识，掌握图像视觉算法基础理论知识；',
            p1: '2、熟练掌握至少一种编程语言：C/C++、Java、Python、Scala、R；',
            p2:
              '3、熟练掌握至少一种深度学习平台：Tensorflow、Caffe、MXNET、Torch、Keras；',
            p3:
              '4、具备图像处理领域知识，例如：人脸识别、物体检测、图像分类、图像搜索；',
            p4:
              '5、熟悉Android系统开发和架构，并有图像算法在手机终端的移植优化经验者优先。'
          }
        },
        {
          name: '语音识别工程师',
          list: {
            p0:
              '1、有深度学习，语音识别、最优化方法等方面较强的研究或应用背景，熟悉常用语音识别声学模型相关算法和工具（Kaldi, tensorflow等）；',
            p1: '2、熟练掌握C/C++/Python语言，有较强的算法分析和实现能力。'
          }
        },
        {
          name: '自然语言理解工程师',
          list: {
            p0: '1、计算机相关基础知识，熟悉的基本数据结构知识，工程能力强；',
            p1:
              '2、扎实的NLP基础，熟悉常用分词算法，本体识别，依存分析，特征提取等；',
            p2:
              '3、熟悉深度学习算法（LSTM，Attention，GAN，VAE，Transformer），能够根据任务需求实现和修改模型，并成功应用到NLP领域；',
            p3: '4、自动问答、意图识别、知识图谱等方面知识。'
          }
        },
        {
          name: '人工智能数据工程师',
          list: {
            p0: '1、 掌握爬虫的原理、技术，能够使用Python熟练编写爬虫软件；',
            p1: '2、 掌握常用的数据分析及可视化的方法、工具并快速实现。'
          }
        }
      ]
      // 产品、技术测试类
      tabList1= [
        {
          name: '智能终端应用开发工程师',
          list: {
            p0: '1、熟悉Linux、Ubuntu常用操作、配置及命令；',
            p1: '2、熟悉常用协议MQTT/CoAP/HTTP等；',
            p2:
              '3、独立开发过Androi/ios应用，熟悉APP开发技术-UI/多线程/网络/消息处理机制；',
            p3: '4、能够快速学习其他物联开发语言lua，c等。'
          }
        }
      ]
      // 系统运维类
      tabList2= [
        {
          name: '智能终端运维工程师',
          list: {
            p0: '1、具有智能硬件、网络通信等相关知识；',
            p1:
              '2、了解智能终端运行的基本原理，熟悉智能终端的结构、常用操作等；',
            p2: '3、具有终端产品故障诊断和处理能力。'
          }
        },
        {
          name: '人工智能平台运维工程师',
          list: {
            p0:
              '1、熟练掌握Linux操作系统，熟悉各项常用命令，尤其是对企业级运维的各项支持；',
            p1: '2、掌握Linux安全与监控、集群与运维技术；',
            p2: '3、掌握云计算、大数据常用的工具、平台等；',
            p3:
              '4、掌握应用人工智能常用工具快速搭建人工智能应用系统，并进行系统的验证；',
            p4:
              '5、能够使用各项工具对人工智能的系统运行状态进行监控、故障排除及系统调优。'
          }
        }
      ]
      // 系统集成与项目实施类
      tabList3= [
        {
          name: '人工智能项目经理',
          list: {
            p0: '1、熟悉产品生命周期全过程，精通软件开发过程规范；',
            p1: '2、熟练使用PowerPoint、Excel、Project、Visio等工具；',
            p2:
              '3、具备较好的发现和解决问题的能力，及时发现问题并找出问题的原因，采取有效的措施推动问题解决；',
            p3:
              '4、熟悉智慧项目相关专业知识，如智慧能源、安防、建筑、安全、水务等，能够具有一个以上相关行业的项目具体设计规划能力；',
            p4:
              '5、熟悉人工智能相关技术趋势，具备面向至少一个以上相关行业的人工智能解决方案设计能力；',
            p5:
              '6、擅于项目管理等沟通协调工作，具有良好的组织策划以及判断分析能力。'
          }
        },
        {
          name: '人工智能实施工程师',
          list: {
            p0:
              '1、熟悉常用软硬件系统和以太网的安装调试及操作，有弱电集成工作经验；',
            p1:
              '2、熟悉RFID、传感、自动控制、无线传输等人工智能技术， 熟悉网络结构、常用网络设备、TCP/IP协议；',
            p2:
              '3、熟悉数据通信产品、无线网络产品、人工智能产品，有人工智能集成项目交付、部署经验。'
          }
        }
      ]
      // 市场营销类
      tabList4= [
        {
          name: '人工智能市场营销经理',
          list: {
            p0: '1、熟悉人工智能产品、智能硬件产品策划运营；',
            p1:
              '2、工作细致，具备良好的文档书写能力，分析问题逻辑条理清晰，具备线下活动策划与组织的能力；',
            p2: '3、熟悉人工智能行业；',
            p3: '4、熟悉人工智能相关技术；',
            p4:
              '5、能够有效收集市场信息，有较强的市场分析和判断能力，敏锐地把握客户需求及市场方向，协助公司制定相关市场策略；',
            p5: '6、熟悉合同法等相关法规，具备一定谈判技巧；',
            p6:
              '7、能够快速理解客户需求及技术背景并传递给技术人员，能判断项目可行性，可以在开发部门配合下编写提案并向客户说明。'
          }
        },
        {
          name: '人工智能市场客户经理',
          list: {
            p0: '1、 熟悉人工智能相关基础知识，了解人工智能常见应用技术架构；',
            p1: '2、 了解人工智能常见应用场景及其场景解决方案；',
            p2: '3、 熟悉人工智能产品及其业务、功能与服务；',
            p3: '4、 了解业内主流人工智能平台特性与优劣势。'
          }
        }
      ]
      // 技术服务、技术支持类
      tabList5= [
        {
          name: '人工智能行业解决方案工程师',
          list: {
            p0:
              '1、对人工智能技术和人工智能业务有很好的理解，对人工智能技术具备深刻的行业发展趋势理解；',
            p1:
              '2、对人工智能技术发展有前瞻性研究；对人工智能解决方案提供商有较深了解；',
            p2: '3、对人工智能有较深理解和认识；',
            p3:
              '4、具备高水平的解决方案编制、交流撰写能力和良好的客户沟通技巧；',
            p4:
              '5、出色的大客户沟通能力和解决方案宣讲技能；需要具备卓越的技术方案交流宣讲能力和理解能力，具备对大客户进行技术性解决方案开发和销售能力。'
          }
        },
        {
          name: '人工智能产品经理',
          list: {
            p0:
              '1、技术背景，熟悉智能交通、车联网、人工智能等行业，具备相对宽广的知识面和行业视野，对前装/后装市场、实现技术、体系架构、硬件产品、软件平台等有良好理解和实践；',
            p1: '2. 熟悉人工智能平台实施或产品开发；',
            p2:
              '3、熟悉WiFi/BLE/ZigBee/LoRa/NB-IoT/eMTC等无线通讯协议、熟悉CoAP/MQTT等人工智能协议；',
            p3:
              '4、逻辑思维能力强，商业触觉敏感，对市场需求有很强的洞察力，能够快速掌握业务流程；',
            p4:
              '5、具备良好的需求分析和产品设计能力，可以完成PRD等标准产品文档撰写；',
            p5: '6、熟悉人工智能业务应用、平台开发。'
          }
        },
        {
          name: '人工智能售前/售后工程师',
          list: {
            p0: '1、熟悉人工智能产品与技术及解决方案；',
            p1: '2、了解人工智能产品特性，能够根据产品特性编写技术方案；',
            p2:
              '3、了解人工智能产品交付实施部署流程，能够定位产品使用过程中出现的问题并解决。'
          }
        }
      ]
}

</script>
<style lang="less" scoped>
/deep/.el-icon-arrow-right,
/deep/.el-icon-arrow-left {
  font-size: 30px;
  margin-top: 5px;
}
/deep/.el-icon-arrow-right::before,
/deep/.el-icon-arrow-left:before,
/deep/.el-tabs__item:hover,
/deep/.el-tabs__item.is-active {
  color: #dd0011;
}

/deep/.el-tabs__active-bar {
  background-color: #dd0011;
}
/deep/.el-tabs__item {
  font-size: 1.125rem;
}
// 切换导航栏显示内容
._center {
  padding-bottom: 3.4375rem;
}
.conent {
  background-color: #f8f8f8;
  .conent_box {
    // height: 500px;
    padding: 2.8125rem 5rem 0;
    h3 {
      font-size: 1.75rem;
      text-align: center;
      color: #333;
    }
    .selected {
      display: block;
      width: 1.5625rem;
      height: 0.1875rem;
      background-color: #333333;
      margin: 0.625rem auto 0;
    }
    .classification {
      // border-bottom: 1px solid #ccc;
      display: flex;
      justify-content: space-around;
      padding: 3.125rem 0 0;
      // 选中时字体颜色显示图片
      .active {
        color: #dd0011;
        img {
          opacity: 1;
        }
      }
      p {
        cursor: pointer;
        font-size: 1.125rem;
        color: #333;
        font-weight: 500;
        position: relative;
        padding-bottom: 10px;
        img {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          opacity: 0;
          z-index: 3333;
        }
      }
    }
    .engineer {
      padding: 2.25rem 6.25rem 4.375rem;
      .engineerClass {
        background-color: #fff;
        margin-bottom: 0.4375rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .engineerTitle {
          width: 200px;
          padding: 10px;
          font-size: 1.125rem;
          color: #333;
          text-align: center;
        }
        .engineerText {
          flex: 1;
          padding: 0.625rem;
          border-left: 1px solid #ccc;
          font-size: 0.875rem;
          color: #666;
        }
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .WidCon {
    padding: 0 5%;
  }
}
@media screen and (max-width: 768px) {
  // 背景
  .Banner {
    .BannerFont {
      h1 {
        font-size: 24px;
      }
      p,
      div {
        font-size: 20px;
      }
    }
  }
  // 导航
  .ExpertNav ul {
    flex-wrap: wrap;
    justify-content: space-evenly;
    li {
      border-left: 1px solid #ccc;
      margin-top: 0.3125rem;
    }
  }
  // 岗位模型分析导航
  .conent {
    .conent_box {
      h3 {
        font-size: 18px;
      }
      padding: 0.625rem;
      .classification {
        align-content: center;
        flex-wrap: wrap;
        padding-top: 0.9375rem;
        p {
          font-size: 14px;
          padding: 0 10px;
        }
        .active {
          margin-bottom: 0.625rem;
        }
      }
      .engineer {
        padding: 0.625rem 0;
        .engineerClass {
          flex-direction: column;
          .engineerText {
            width: 100%;
            border-left: 0;
          }
        }
      }
    }
  }
  .conent .conent_box .classification p img {
    bottom: -10px;
  }
  .conent_box {
    padding-top: 20px !important;
  }
}
</style>
